import { FC } from "react";
import Section from "../Section";
import Button from "../Button";
import styles from "./Hero.module.scss";

export interface HeroButtonConfig {
  text: string;
  to?: string;
  href?: string;
  variant?: "primary" | "secondary" | "outline" | "outlineLight";
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
}

interface HeroProps {
  eyebrow: string;
  heading: string;
  copy: string;
  backgroundImage: string;
  button: HeroButtonConfig;
  secondaryButton?: HeroButtonConfig;
}

const Hero: FC<HeroProps> = ({
  eyebrow,
  heading,
  copy,
  backgroundImage,
  button,
  secondaryButton,
}) => {
  return (
    <Section
      fullWidthContent
      bgColor="transparent"
      sectionClass={styles.heroSection}
    >
      <div
        className={styles.heroBackground}
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className={styles.heroOverlay} />
        <div className={styles.heroInner}>
          <div className={styles.heroContent}>
            <h1 className={styles.eyebrow}>{eyebrow}</h1>
            <h2 className={styles.heroHeading}>{heading}</h2>
            <p className={styles.heroCopy}>{copy}</p>
            <div className={styles.heroCtas}>
              <Button
                to={button.to}
                href={button.href}
                variant={button.variant || "secondary"}
                size={button.size || "lg"}
                onClick={button.onClick}
              >
                {button.text}
              </Button>
              {secondaryButton && (
                <Button
                  to={secondaryButton.to}
                  href={secondaryButton.href}
                  variant={secondaryButton.variant || "outlineLight"}
                  size={secondaryButton.size || "lg"}
                  onClick={secondaryButton.onClick}
                >
                  {secondaryButton.text}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Hero;
